import { FiboSuggestionItem } from '../../../model';

export type FiboSearchRequest = {
  s: string;
};

export type FiboSearchResponse = {
  suggestions: FiboSuggestionItem[];
  total: number;
  tntTime: string;
  time: string;
  engine: string;
  v: string;
};
